import moment from 'moment-timezone';
// capitalize #163
var monthNames = ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "Septemper", "Oktober", "November", "December" ];
var weekDay = ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön" ];
var weekDayAdjust = ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag" ];

/**
 * Get the ISO week date week number
 */
 // eslint-disable-next-line
    Date.prototype.getWeek = function () {
      // Create a copy of this date object
      var target  = new Date(this.valueOf());

      // ISO week date weeks start on monday
      // so correct the day number
      var dayNr   = (this.getDay() + 6) % 7;

      // ISO 8601 states that week 1 is the week
      // with the first thursday of that year.
      // Set the target date to the thursday in the target week
      target.setDate(target.getDate() - dayNr + 3);

      // Store the millisecond value of the target date
      var firstThursday = target.valueOf();

      // Set the target to the first thursday of the year
      // First set the target to january first
      target.setMonth(0, 1);
      // Not a thursday? Correct the date to the next thursday
      if (target.getDay() !== 4) {
        target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
      }

      // The weeknumber is the number of weeks between the
      // first thursday of the year and the thursday in the target week
      return 1 + Math.ceil((firstThursday - target) / 604800000); // 604800000 = 7 * 24 * 3600 * 1000
    }

class DateTime {
    static getCurrentWeek(){
        return new Date().getWeek()
    }

    static getMonth(dateString, long=false){
        const date = this.getUTCDate(dateString)
        if(long) return monthNames[date.getMonth()]
        return monthNames[date.getMonth()].slice(0,3)
    }
    static getMonthByIndex(index, long=false){
        if(long) return monthNames[index]
        return monthNames[index].slice(0,3)
    }
    static getSingleDate(dateString){
        return this.getUTCDate(dateString).getDate()
    }
    static getDayOfTheWeek(dateString){
        const date = this.getUTCDate(dateString)
        return weekDayAdjust[date.getDay()]

    }
    static formatDate(dateString, format) {
        if(!dateString) return '';
        const date = this.getUTCDate(dateString);
        switch (format) {
            case 'hh:mm':
                return this.__getTime(date);
            case 'yyyy-mm-dd':
                return this.getDate(date);
            case 'yyyy-mm-dd hh:mm':
                return `${this.getDate(date)} ${this.__getTime(date)}`;
            default:
                return `${this.getDate(date)} ${this.__getTime(date)}`;
        }
    }

    static getUTCDate(dateString) {
        if(!dateString) return ''
        // replace - with / in dateString for browser compatibility.
        dateString = dateString.replace(/-/g, "/");

        // Entries that come via socket have a date then a dot followed by a 6 digit number that should not be in the date
        dateString = dateString.split('.')[0];
        return new Date(dateString);
    }

    static __getTime(date) {
        //const hours = this.padDate(date.getUTCHours());
        const hours = this.padDate(date.getHours());

        //const minutes = this.padDate(date.getUTCMinutes());
        const minutes = this.padDate(date.getMinutes());
        return `${hours}:${minutes}`;
    }

    static getHour(dateString){
        return this.getUTCDate(dateString).getUTCHours()
    }

    static getTime(dateString) {
        return this.__getTime(this.getUTCDate(dateString))
    }

    static getDate(date) {
        const year = date.getFullYear();
        const month = this.padDate(date.getMonth() + 1);
        const day = this.padDate(date.getDate());
        return `${year}-${month}-${day}`;
    }

    static padDate(number) {
        number = String(number);

        if (number.length === 1) {
            number = `0${number}`;
        }
        return number;
    }

    static isToday(dateString) {
        const date = this.getUTCDate(dateString);

        const today = new Date();

        return today.toDateString() === date.toDateString();
    }

    static getFormatDate(dateString) {
        if(!dateString) return ''
        const date = this.getUTCDate(dateString);
        const year = date.getFullYear();
        const month = this.padDate(date.getMonth() + 1);
        const day = this.padDate(date.getDate());
        return `${year}-${month}-${day}`;
    }

    static getDetailedNiceDate(dateString, short) {
        //UTC TO LOCALTIME
        var formatDate = moment.utc(dateString).format('YYYY-MM-DD HH:mm:ss');;
        var utcTime = moment.utc(formatDate).toDate();
        var localTime = moment(utcTime).local().format('YYYY-MM-DD HH:mm:ss');

        if(!dateString) return ''
        const date = this.getUTCDate(localTime); //Yeah converting localtime to date object
        const today = new Date()
        if (this.isToday(dateString))
            return "Idag " + this.__getTime(date);
        const weekDate = date.getDay()
        const month = date.getMonth()

        var timeDiff = Math.abs(today.getTime() - date.getTime());
        var diffDays = timeDiff / (1000 * 3600 * 24);
        if (diffDays < 2)
            return "Igår " + this.__getTime(date);
        if (diffDays < 7) {
            if(short) return `${weekDayAdjust[weekDate].slice(0,3)} ${this.__getTime(date)}`;
            return `${weekDayAdjust[weekDate]} ${this.__getTime(date)}`;
        }

        if(short) return `${date.getDate()} ${monthNames[month].slice(0,3)} ${this.__getTime(date)}`;
        return `${date.getDate()} ${monthNames[month]} ${this.__getTime(date)}`;
    }

    static getNiceDate(dateString) {
        if(!dateString) return ''
        const date = this.getUTCDate(dateString);
        const today = new Date();
        if (this.isToday(dateString))
            return 'Idag';

        const weekDate = date.getDay()
        const month = date.getMonth()

          var timeDiff = Math.abs(today.getTime() - date.getTime());
          var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
          if (diffDays === 1)
              return "Igår";
          if (diffDays < 7)
              return `${weekDayAdjust[weekDate]}`;


        return `${date.getDate()} ${monthNames[month]}`;

    }

    static getDiffTime(here, there){
        let hereDate = this.getUTCDate(here);
        let thereDate = this.getUTCDate(there);
        return Math.abs(hereDate - thereDate);
    }


    static getDiffSecond(here, there){
        return Math.ceil(this.getDiffTime(here,there)/(1000));
    }

    static getDiffMinutes(here, there){
        return Math.ceil(this.getDiffTime(here,there)/(1000*60));
    }
    static getDiffHours(here, there){
        return Math.ceil(this.getDiffTime(here,there)/(1000*3660));
    }
    static getDiffDays(here, there){
        return Math.ceil(this.getDiffTime(here, there)/(1000*3660*24));
    }

    static convertSecondsToHour(seconds){
        const hour = Math.floor(seconds / 3600);
        const minut = Math.floor((seconds - hour*3600)/60);
        const second = seconds - hour*3600  - minut*60;
        let time = ''
        if(hour) time += hour + 'h'
        if(minut) time+= ' ' + minut + 'm'
        if(second) time+= ' ' + second + 's'
        return time
    }
    static convertMinutesToHour(minutes){
        let time = []
        const hour = Math.floor(minutes / 60);
        const minut = minutes - hour*60;
        hour? time.push(hour): time.push(0)
        minut? time.push(minut): time.push(0)
        return time
    }


    static arrayToWeekDates(lst){
        if(!lst){
            return 'nothing here'
        }
        if(lst.size === 7){
            return 'Alla'
        }

        let days= weekDay[parseInt(lst[0], 10)]
        for(var i = 1; i < lst.length; i++){
            days += ',' + weekDay[parseInt(lst[i], 10)]
        }

        return days
    }

}

export default DateTime;



// WEBPACK FOOTER //
// ./src/lib/DateTime.js